export const EXPIRATION_LINK_IN_MINUTES = 30;
export const ID_ASSIST_KEY = '@tempoassist/idAssistServico';
